export const SET_ACCOUNTS = "SET_ACCOUNTS";
export const CLEAR_ACCOUNTS = "CLEAR_ACCOUNTS";
export const CHANGE_ACCOUNT = "CHANGE_ACCOUNT";
export const INIT_ACCOUNTS = "INIT_ACCOUNTS";
